/* RESPONSIBLE TEAM: team-ai-agent */
import IntercomRoute from 'embercom/routes/base/intercom-route';
import { ReactRoute } from 'embercom/lib/react-route';

class AutomationFinAIAgentGuidanceV2Route extends IntercomRoute {
  analytics = {
    section: 'automation',
    place: 'fin-ai-agent.guidance-v2',
  };

  reactEnabled() {
    return true;
  }
}

export default ReactRoute(AutomationFinAIAgentGuidanceV2Route, {
  overrideRenderTemplate: false,
});
